import { render } from "./fb-vog-live-icon.svg?vue&type=template&id=2f4ac168"
const script = {}
script.render = render

export default script